module.exports = __webpack_public_path__ + "img/19.152e8920.png";